export default "__VITE_ASSET__BnV2SB52__"